import { render, staticRenderFns } from "./LenderGradeBook.vue?vue&type=template&id=be104ece"
import script from "./LenderGradeBook.vue?vue&type=script&lang=js"
export * from "./LenderGradeBook.vue?vue&type=script&lang=js"
import style0 from "./LenderGradeBook.vue?vue&type=style&index=0&id=be104ece&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports